export const TOKEN_EXPIRY_DAYS = 90 // 3 months token expiry

/**
 * Calculate token expiry time in Unix seconds
 * @param currentTime - Current time in seconds (optional, defaults to current time)
 * @returns {number} - Token expiry time in UNIX seconds
 */
export function calculateTokenExpiry(currentTime = Math.floor(Date.now() / 1000)): number {
  return Math.floor(currentTime) + (TOKEN_EXPIRY_DAYS * 24 * 60 * 60)
}

/**
 * Checks if the token is valid
 * @param token - The authentication token
 * @returns boolean - true if token is valid, false if expired or invalid
 */
export function isTokenValid(token: string | null): boolean {
  return typeof token === 'string' && token.trim().length > 0
}

/**
 * Checks if the provided auth token expiry has passed
 * @param tokenExpiry - The expiry time in UNIX seconds
 * @returns {boolean} - true if token is expired or invalid, false if valid
 */
export function isTokenExpired(tokenExpiry: number | null): boolean {
  if (!tokenExpiry) {
    return true
  }

  if (Math.floor(new Date().getTime() / 1000) > tokenExpiry) {
    return true
  }

  return false
}

/**
 * Calculates the remaining time in seconds until token expiry
 * @param tokenExpiry - The token expiry time in UNIX seconds
 * @returns {number} - Remaining time in seconds until token expiry, or 0 if expired
 */
export function calculateTimeRemaining(tokenExpiry: number | null): number {
  if (!tokenExpiry) {
    return 0
  }

  const remainingSec = tokenExpiry - Math.floor(Date.now() / 1000)
  return remainingSec > 0 ? remainingSec : 0
}
